export default __webpack_public_path__ + "static/media/radiant-bright-purple-red.5cca72d1.jpg";